// import { RootState } from 'theSource/app/store';

// TODO: change this once life event context is implemented
export const selectLifeEventCompleted = () => {
  // if (state.enrollment.lifeEventCompleted.lifeEventCompleted === '') {
  //   return String(localStorage.getItem('lifeEventCompleted'));
  // }

  // return state.enrollment.lifeEventCompleted.lifeEventCompleted;
  return false;
};
